(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blackfriday26"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.MangoalBF26?.version === "2026.11.04.2") { window.MangoalBF26.scan(); return; }
  const instances = new Map();
  const clamp = (v) => Math.max(0, Math.min(1, v));
  class Campaign {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.intro = root.querySelector('[data-intro]');
      this.stage = root.querySelector('[data-stage]');
      this.year = root.querySelector('[data-year]');
      this.introCopy = root.querySelector('[data-intro-copy]');
      this.heroCopy = root.querySelector('[data-hero-copy]');
      this.media = root.querySelector('[data-hero-media]');
      this.seal = root.querySelector('[data-seal]');
      this.scenes = [...root.querySelectorAll('[data-year-scene]')];
      this.yearButtons = [...root.querySelectorAll('[data-year-button]')];
      this.progressLine = root.querySelector('[data-scroll-progress]');
      this.sticky = root.querySelector('[data-sticky]');
      this.labels = JSON.parse(root.querySelector('[data-labels]').textContent);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.lastScene = -2;
      this.dates = [root.dataset.memberStart,root.dataset.publicStart,root.dataset.campaignEnd].map(value => /^\d{4}-\d\d-\d\dT\d\d:\d\d(?::\d\d)?(?:Z|[+-]\d\d:\d\d)$/.test(value || '') ? Date.parse(value) : NaN);
      this.validDates = this.dates.every(Number.isFinite) && this.dates[0] < this.dates[1] && this.dates[1] < this.dates[2];
      this.ui = Object.fromEntries(['campaign-status','sticky-label','countdown-title','countdown','sticky-link'].map(name => [name,root.querySelector('[data-'+name+']')]));
      this.finaleButton = root.querySelector('[data-finale-button]');
      this.root.style.setProperty('--bf-intro-screens', String(Math.min(4.2, 2.3 + this.scenes.length * 0.55)));
      this.root.classList.add('is-enhanced');
      this.listen();
      this.setMotion();
      this.railObservers = [];
      this.setupLookbook();
      this.setupReveals();
      this.updateCampaign();
      this.startClock();
      this.measure();
    }
    startClock() {
      clearInterval(this.interval);
      if (!document.hidden) this.interval = setInterval(() => this.updateCampaign(), 1000);
    }
    listen() {
      const opts = {signal:this.signal};
      window.addEventListener('scroll', () => this.queue(), {passive:true, signal:this.signal});
      window.addEventListener('resize', () => this.measure(), {passive:true, signal:this.signal});
      document.addEventListener('visibilitychange', () => {clearInterval(this.interval);if(!document.hidden){this.updateCampaign();this.startClock();this.measure();}}, opts);
      this.motion.addEventListener('change', () => {this.setMotion();this.measure();}, opts);
      this.yearButtons.forEach((button, index) => button.addEventListener('click', () => this.seek(.12 + ((index + .5) / this.scenes.length) * .65), opts));
      this.root.querySelector('[data-finale-button]')?.addEventListener('click', () => this.seek(1), opts);
      this.root.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if(!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        const href = link.getAttribute('href');
        if(!href || !href.startsWith('#' + this.root.id + '-')) return;
        const destination = document.getElementById(href.slice(1));
        if(!destination) return;
        event.preventDefault();
        destination.scrollIntoView({behavior:this.motion.matches?'instant':'smooth',block:'start'});
        const heading = destination.querySelector('h2,h3');
        if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
      }, opts);
    }
    setMotion() {
      this.root.classList.toggle('is-reduced',this.motion.matches);
      const nav = this.root.querySelector('[data-year-nav]');
      if(nav) nav.hidden = this.motion.matches || !this.scenes.length;
      if(this.motion.matches){
        [this.year,this.introCopy,this.heroCopy,this.media,this.seal].forEach(el => {if(el){el.style.removeProperty('opacity');el.style.removeProperty('transform');el.inert=false;el.removeAttribute('aria-hidden');}});
        this.revealObserver?.disconnect();
        this.root.querySelectorAll('.is-entering').forEach(el=>el.classList.remove('is-entering'));
      }
    }
    measure() {
      const rect = this.intro.getBoundingClientRect();
      this.introTop = rect.top + window.scrollY;
      this.offset = parseFloat(getComputedStyle(this.root).getPropertyValue('--bf-offset')) || 0;
      this.introHeight = this.intro.offsetHeight;
      this.distance = Math.max(1,this.introHeight-this.stage.offsetHeight);
      this.lastProgress = undefined;
      this.rootTop = this.root.getBoundingClientRect().top + window.scrollY;
      this.rootBottom = this.rootTop + this.root.offsetHeight;
      this.queue();
    }
    queue() {
      if(this.frame) return;
      this.frame = requestAnimationFrame(() => {this.frame=0;this.render();});
    }
    seek(progress) {
      if(this.motion.matches) return;
      window.scrollTo({top:this.introTop-this.offset+this.distance*progress,behavior:'smooth'});
    }
    render() {
      const scroll = window.scrollY;
      const introPassed = scroll > this.introTop + this.introHeight - innerHeight * .35;
      const rootVisible = scroll + innerHeight > this.rootTop && scroll + innerHeight < this.rootBottom - 180;
      const stickyHidden = !introPassed || !rootVisible;
      if (this.sticky.hidden !== stickyHidden) this.sticky.hidden = stickyHidden;
      if(this.motion.matches) return;
      const p = clamp((scroll - this.introTop + this.offset)/this.distance);
      if (p === this.lastProgress) return;
      this.lastProgress = p;
      this.progressLine.style.transform = `scaleX(${p})`;
      const opening = 1-clamp((p-.045)/.095);
      const finale = clamp((p-(this.scenes.length ? .78 : .3))/(this.scenes.length ? .16 : .3));
      this.introCopy.style.opacity = String(opening);
      this.introCopy.style.transform = `translateY(${-clamp(p/.15)*18}px)`;
      this.heroCopy.style.opacity = String(finale);
      this.heroCopy.style.transform = `translateY(${(1-finale)*25}px)`;
      this.heroCopy.inert = finale < .8;
      this.heroCopy.setAttribute('aria-hidden',String(finale < .8));
      this.seal.style.opacity = String(finale);
      this.media.style.transform = `scale(${1.02 + clamp(p)*.1})`;
      this.media.style.opacity = String(.18 + finale*.16);
      const selected = p>=.12 && p<.79 && this.scenes.length ? Math.min(this.scenes.length-1,Math.floor(clamp((p-.12)/.65)*this.scenes.length)) : -1;
      if(selected!==this.lastScene){
        this.scenes.forEach((scene,index)=>{const active=index===selected;scene.classList.toggle('is-current',active);scene.inert=!active;scene.setAttribute('aria-hidden',String(!active));});
        this.yearButtons.forEach((button,index)=>{if(index===selected)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});
        const endButton=this.finaleButton;
        if(endButton){if(p>=.79)endButton.setAttribute('aria-current','step');else endButton.removeAttribute('aria-current');}
        this.year.textContent=selected>=0?this.scenes[selected].dataset.yearValue:(this.yearButtons[0]?.dataset.yearButton || this.root.dataset.year || '2026');
        this.lastScene=selected;
      }
      this.year.style.opacity=String(selected>=0?.07:opening);
      this.year.style.transform=`scale(${1+clamp(p/.15)*.12})`;
      if(selected>=0){
        const local=((p-.12)/.65*this.scenes.length)-selected;
        this.scenes[selected].style.opacity=String(clamp(local/.14)*clamp((1-local)/.12));
      }
    }
    setupLookbook() {
      this.root.querySelectorAll('[data-lookbook-selection]').forEach(selection => {
        const rail = selection.querySelector('[data-lookbook-rail]');
        const controls = selection.querySelector('[data-rail-controls]');
        const previous = selection.querySelector('[data-rail-prev]');
        const next = selection.querySelector('[data-rail-next]');
        const update = () => {
          const overflow = rail.scrollWidth - rail.clientWidth;
          controls.hidden = overflow < 2;
          previous.disabled = rail.scrollLeft < 2;
          next.disabled = rail.scrollLeft >= overflow - 2;
        };
        const move = direction => {
          const product = rail.querySelector('.mgbf-lookbook-product');
          if (!product) return;
          const step = product.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
          rail.scrollBy({left:direction * step, behavior:this.motion.matches ? 'instant' : 'smooth'});
        };
        previous.addEventListener('click', () => move(-1), {signal:this.signal});
        next.addEventListener('click', () => move(1), {signal:this.signal});
        rail.addEventListener('scroll', update, {passive:true, signal:this.signal});
        window.addEventListener('resize', update, {passive:true, signal:this.signal});
        if (typeof ResizeObserver !== 'undefined') {
          const observer = new ResizeObserver(update);
          observer.observe(rail);
          this.railObservers.push(observer);
        }
        update();
      });
    }

    setupReveals() {
      if(this.motion.matches || !('IntersectionObserver' in window))return;
      this.root.classList.add('mgbf-animate');
      this.revealObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-entering');this.revealObserver.unobserve(entry.target);}});},{rootMargin:'0px 0px -30px 0px',threshold:.08});
      this.root.querySelectorAll('.mgbf-section-head,.mgbf-spotlight-copy').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('is-entering');this.revealObserver.observe(el);}});
      this.resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(()=>this.measure()) : null;
      this.resizeObserver?.observe(this.root);
    }
    updateCampaign() {
      const dates=this.dates;
      const valid=this.validDates;
      const now=Date.now();
      let phase=this.root.dataset.state;
      if(this.root.dataset.auto==='true'&&valid)phase=now<dates[0]?'teaser':now<dates[1]?'members':now<dates[2]?'public':'ended';
      if(!['teaser','members','public','ended'].includes(phase))phase='teaser';
      if (phase !== this.lastPhase) {
      this.root.dataset.currentPhase=phase;
      const status=this.labels[phase];
      this.ui['campaign-status'].textContent=status;
      this.ui['sticky-label'].textContent=status;
      const label=phase==='members'?this.labels.public_next:phase==='public'?this.labels.ends:phase==='ended'?this.labels.ended:this.labels.next;
      this.ui['countdown-title'].textContent=label;
      const link=this.ui['sticky-link'];
      const shop=phase==='public'||phase==='ended'||(phase==='members'&&this.root.dataset.member==='true');
      link.href=shop?'#'+this.root.id+'-offers':this.labels.member_url;
      link.replaceChildren(document.createTextNode(shop?this.labels.shop_action:this.labels.member_action));
      const arrow=document.createElement('span');arrow.setAttribute('aria-hidden','true');arrow.textContent='↗';link.append(arrow);
        this.lastPhase=phase;
      }
      const end=phase==='teaser'?dates[0]:phase==='members'?dates[1]:dates[2];
      let output=this.labels.pending;
      if(phase==='ended')output='—';
      else if(valid){const seconds=Math.max(0,Math.floor((end-now)/1000));const days=Math.floor(seconds/86400);const hours=Math.floor(seconds%86400/3600);const mins=Math.floor(seconds%3600/60);const secs=seconds%60;const units=this.labels.countdown_units.split('|');output=`${String(days).padStart(2,'0')}${units[0]} ${String(hours).padStart(2,'0')}${units[1]} ${String(mins).padStart(2,'0')}${units[2]} ${String(secs).padStart(2,'0')}${units[3]}`;}
      if(this.ui.countdown.textContent!==output)this.ui.countdown.textContent=output;

    }
    destroy() {this.railObservers.forEach(observer=>observer.disconnect());this.abort.abort();clearInterval(this.interval);cancelAnimationFrame(this.frame);this.revealObserver?.disconnect();this.resizeObserver?.disconnect();}
  }
  const scan=()=>document.querySelectorAll('[data-mgbf]').forEach(root=>{if(!instances.has(root)){try{instances.set(root,new Campaign(root));}catch(error){root.classList.remove('is-enhanced');console.error('MANGOAL campaign initialization failed',error);}}});
  window.MangoalBF26={scan,version:"2026.11.04.2"};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',event=>{instances.forEach((instance,root)=>{if(event.target.contains(root)){instance.destroy();instances.delete(root);}});});
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mangoal-gift-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initGiftReviews(root) {
    if (root.dataset.reviewBound) return;
    root.dataset.reviewBound = 'true';
    const labels = JSON.parse(root.querySelector('[data-review-labels]').textContent);
    const form = root.querySelector('[data-review-lookup]');
    const status = root.querySelector('[data-review-status]');
    const results = root.querySelector('[data-review-lookup-results]');
    const submit = root.querySelector('[data-review-submit]');
    const host = root.querySelector('[data-review-native-host]');
    let modal = null;
    let titleObserver = null;
    let opening = false;
    const safeProductUrl = value => {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(url.pathname)) throw Error('invalid_product');
      return url.pathname + '#judgeme_product_reviews';
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submit.disabled || !form.reportValidity()) return;
      submit.disabled = true;
      status.textContent = labels.loading;
      results.replaceChildren();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('/apps/drive-win-v2/review-products', { method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json' }, signal: controller.signal, body: JSON.stringify({ orderNumber: form.elements.review_order.value.trim(), email: form.elements.review_email.value.trim() }) });
        const data = await response.json().catch(() => null);
        if (!data) throw new TypeError('lookup_unavailable');
        if (!response.ok || !data.ok || !Array.isArray(data.products)) throw Error(data.message || labels.error);
        const cards = [];
        for (const product of data.products) {
          if (!/^\d+$/.test(String(product.id))) continue;
          const url = safeProductUrl(product.url);
          const card = document.createElement('article'); card.className = 'mgo-gift-reviews__product';
          if (product.image) {
            const imageUrl = new URL(product.image, location.origin);
            if (imageUrl.protocol === 'https:') { const image = document.createElement('img'); image.className = 'mgo-gift-reviews__image'; image.src = imageUrl.href; image.alt = ''; image.loading = 'lazy'; image.width = 80; image.height = 80; card.append(image); }
          }
          const info = document.createElement('div'); info.className = 'mgo-gift-reviews__product-info';
          const title = document.createElement('h3'); title.textContent = product.title; info.append(title); card.append(info);
          const link = document.createElement('a'); link.className = 'mgo-gift-reviews__button mgo-gift-reviews__button--small'; link.href = url; link.textContent = labels.write; link.dataset.reviewProduct = ''; link.dataset.productId = String(product.id); link.dataset.productTitle = product.title; link.dataset.productImage = product.image || ''; card.append(link); cards.push(card);
        }
        results.replaceChildren(...cards);
        status.textContent = cards.length ? '' : labels.empty;
      } catch (error) { status.textContent = error.name === 'AbortError' || error instanceof TypeError ? labels.error : error.message; }
      finally { clearTimeout(timer); submit.disabled = false; }
    });
    const waitFor = (check, timeout = 8000) => new Promise((resolve, reject) => {
      const started = Date.now();
      const poll = () => { if (check()) resolve(); else if (Date.now() - started >= timeout) reject(Error('judge_unavailable')); else setTimeout(poll, 80); }; poll();
    });
    async function judgeReady() {
      await waitFor(() => window.jdgm && typeof window.jdgm.loadScript === 'function');
      const judge = window.jdgm;
      if (!judge.$) { judge.loadScript('widget/base.js'); await waitFor(() => judge.$); }
      if (!judge.initializeWidgets) { judge.loadScript('widget/common.js'); await waitFor(() => judge.initializeWidgets); }
      if (!judge._renderAndSetupReviewForm) { judge.loadScript('widget/form.js'); await waitFor(() => judge._renderAndSetupReviewForm); }
      if (!judge._WriteReviewModal) { judge.loadScript('widget/write_review_modal.js'); await waitFor(() => judge._WriteReviewModal); }
      if (typeof judge.loadCSS === 'function') {
        judge.loadCSS(judge.widgetPath('base.css')); judge.loadCSS(judge.widgetPath('main.css')); judge.loadCSS(judge.widgetPath('form.css'));
        await waitFor(() => Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link => /(?:\/|_)form\.css(?:\?|$)/.test(link.href) && link.sheet && link.media !== 'print'));
      }
      return judge;
    }
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-review-product]');
      if (!link || !root.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (opening) return;
      opening = true; link.setAttribute('aria-busy', 'true'); status.textContent = labels.opening;
      try {
        const judge = await judgeReady();
        if (!window.jdgmSettings || !window.jdgmSettings.modal_write_review_flow || window.jdgmSettings.disable_web_reviews || (typeof judge.checkCustomerAccountRestriction === 'function' && !judge.checkCustomerAccountRestriction())) throw Error('judge_unavailable');
        if (titleObserver) titleObserver.disconnect();
        if (modal) { if (typeof modal._closeModal === 'function') modal._closeModal(); if (modal.$modal) modal.$modal.remove(); }
        host.className = 'jdgm-widget jdgm-review-widget';
        host.dataset.productTitle = link.dataset.productTitle;
        host.dataset.id = link.dataset.productId;
        host.replaceChildren();
        const widget = document.createElement('div'); widget.className = 'jdgm-rev-widg'; widget.dataset.imageUrl = link.dataset.productImage || ''; host.append(widget);
        judge.$(host).removeData('product-title').removeData('id');
        modal = new judge._WriteReviewModal(judge.$);
        const ready = await modal.setup('jdgm-review-widget-modal', link.dataset.productId);
        if (!ready || String(modal.productId) !== link.dataset.productId) throw Error('judge_unavailable');
        const keepTitleIndependent = () => modal.$modal.find('input[name="review_title"]').attr('data-manually-edited', 'true').data('manually-edited', true);
        keepTitleIndependent();
        titleObserver = new MutationObserver(keepTitleIndependent);
        titleObserver.observe(modal.$modal[0], { childList: true, subtree: true });
        modal.showModalPage();
        status.textContent = '';
      } catch {
        status.replaceChildren(document.createTextNode(labels.fallback + ' '));
        const fallback = document.createElement('a'); fallback.href = link.href; fallback.textContent = labels.write; status.append(fallback);
      } finally { opening = false; link.removeAttribute('aria-busy'); }
    });
  }
  const init = container => container.querySelectorAll('[data-gift-reviews]').forEach(initGiftReviews);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-tab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      if (section.dataset.erInitialized === 'true') return;
      const tabs = Array.from(section.querySelectorAll('[data-er-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-er-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      section.dataset.erInitialized = 'true';

      const tablist = section.querySelector('[role="tablist"]');
      const navigation = section.querySelector('[data-er-navigation]');
      let currentIndex = Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));

      const activateTab = (index, moveFocus) => {
        currentIndex = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === currentIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          panels[tabIndex].classList.toggle('is-active', active);
          panels[tabIndex].hidden = !active;
          panels[tabIndex].inert = !active;
          panels[tabIndex].setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        if (moveFocus) tabs[currentIndex].focus({ preventScroll: true });
        const tabBounds = tabs[currentIndex].getBoundingClientRect();
        const listBounds = tablist.getBoundingClientRect();
        if (tabBounds.left < listBounds.left || tabBounds.right > listBounds.right) {
          tablist.scrollTo({
            left: tablist.scrollLeft + tabBounds.left - listBounds.left - (tablist.clientWidth - tabBounds.width) / 2,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index, false));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(nextIndex, true);
          }
        });
      });
      section.querySelector('[data-er-prev]')?.addEventListener('click', () => activateTab(currentIndex - 1, false));
      section.querySelector('[data-er-next]')?.addEventListener('click', () => activateTab(currentIndex + 1, false));
      if (navigation) navigation.hidden = false;
    };

    const initializeReviews = (root) => {
      if (root.matches?.('.expert-reviews')) initializeSection(root);
      root.querySelectorAll('.expert-reviews').forEach(initializeSection);
    };

    initializeReviews(document);
    document.addEventListener('shopify:section:load', (event) => initializeReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npd-pdp-installation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npd-install-video')) {
  customElements.define('npd-install-video', class extends HTMLElement {
    embedUrl(rawUrl, autoplay) {
      let url;
      try { url = new URL(rawUrl.trim()); } catch { return null; }
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      const host = url.hostname.toLowerCase().replace(/^www\./, '');
      const parts = url.pathname.split('/').filter(Boolean);
      let id;
      let embed;
      if (host === 'youtu.be') {
        id = parts[0];
      } else if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
        id = url.searchParams.get('v');
        if (['embed', 'shorts', 'live'].includes(parts[0])) id = parts[1];
      } else if (['vimeo.com', 'player.vimeo.com'].includes(host)) {
        id = host === 'player.vimeo.com' ? parts[1] : parts[0];
        if (!/^\d+$/.test(id || '')) return null;
        embed = new URL('https://player.vimeo.com/video/' + id);
        const hash = url.searchParams.get('h') || (host === 'vimeo.com' ? parts[1] : null);
        if (hash && /^[a-zA-Z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
      }
      if (!embed) {
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return null;
        embed = new URL('https://www.youtube-nocookie.com/embed/' + id);
        embed.searchParams.set('playsinline', '1');
        embed.searchParams.set('rel', '0');
      }
      embed.searchParams.set('autoplay', autoplay ? '1' : '0');
      return embed.href;
    }
    connectedCallback() {
      this.button = this.querySelector('button');
      this.template = this.querySelector('template');
      if (!this.template || this.initialized) return;
      this.initialized = true;
      this.start = () => {
        if (!this.player) {
          const content = this.template.content.cloneNode(true);
          const iframe = content.querySelector('iframe');
          if (iframe) {
            const url = this.embedUrl(iframe.dataset.npdUrl || '', !!this.button);
            if (!url) return;
            iframe.src = url;
          }
          this.player = document.createElement('div');
          this.player.className = 'npd-video__player';
          this.player.append(content);
          this.append(this.player);
        }
        if (this.button) {
          document.querySelectorAll('npd-install-video').forEach(player => {
            if (player !== this) player.stop?.();
          });
          this.button.hidden = true;
        }
        this.player.hidden = false;
        const media = this.player.querySelector('video,iframe');
        if (this.button) media?.focus();
        if (media?.tagName === 'VIDEO') media.play().catch(() => {});
      };
      this.button?.addEventListener('click', this.start);
      if (this.hasAttribute('data-npd-direct')) this.start();
    }
    stop() {
      if (!this.player) return;
      if (!this.button) {
        const iframe = this.player.querySelector('iframe');
        if (iframe) {
          const url = this.embedUrl(iframe.dataset.npdUrl || '', false);
          if (url) iframe.src = url;
        }
        return;
      }
      const video = this.player.querySelector('video');
      if (video) video.pause();
      else { this.player.remove(); this.player = null; }
      if (this.player) this.player.hidden = true;
      this.button.hidden = false;
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.start);
      this.player?.querySelector('video')?.pause();
      this.player?.remove();
      this.player = null;
      if (this.button) this.button.hidden = false;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npd-pdp-night"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('npd-night-compare')) {
  customElements.define('npd-night-compare', class extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type="range"]');
      this.track = this.closest('.npd-night__scroll-track');
      this.stage = this.closest('.npd-night__sticky');
      if (!this.range || !this.track || !this.stage) return;

      const clamp = x => Math.min(100,Math.max(0,x));
      this.current = clamp(Number(this.range.value) || 0);
      this.pointerId = null;
      this.frame = 0;
      this.listenScroll = false;
      this.mode = matchMedia('(min-width:990px) and (pointer:fine) and (prefers-reduced-motion:no-preference)');

      this.paint = () => {
        const p = clamp(this.current);
        this.style.setProperty('--npd-position',p+'%');
        this.style.setProperty('--npd-left-opacity',(p/100).toFixed(3));
        this.style.setProperty('--npd-right-opacity',(1-p/100).toFixed(3));
        this.range.value = p.toFixed(1);
      };
      this.renderScroll = () => {
        this.frame = 0;
        if (!this.mode.matches || this.pointerId !== null) return;
        const rect = this.track.getBoundingClientRect();
        const stageHeight = this.stage.getBoundingClientRect().height;
        const stickyTop = parseFloat(getComputedStyle(this.stage).top) || 0;
        const travel = Math.max(1,rect.height-stageHeight);
        this.current = clamp((stickyTop-rect.top)/travel*100);
        this.paint();
      };
      this.onScroll = () => {
        if (!this.frame) this.frame=requestAnimationFrame(this.renderScroll);
      };
      this.attachScroll = () => {
        if (this.listenScroll) return;
        window.addEventListener('scroll',this.onScroll,{passive:true});
        this.listenScroll = true;
        this.onScroll();
      };
      this.detachScroll = () => {
        if (!this.listenScroll) return;
        window.removeEventListener('scroll',this.onScroll);
        this.listenScroll = false;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      };
      this.updateStickyTop = () => {
        if (!this.mode.matches) {
          this.track.style.removeProperty('--npd-night-sticky-top');
          return;
        }
        const contentHeight = this.stage.getBoundingClientRect().height;
        this.track.style.setProperty('--npd-night-sticky-top',
          Math.max(20, (window.innerHeight - contentHeight) / 2).toFixed(1) + 'px');
        this.onScroll();
      };
      this.onMode = () => {
        if (this.mode.matches) {
          this.updateStickyTop();
        } else {
          this.detachScroll();
          this.track.style.removeProperty('--npd-night-sticky-top');
          this.paint();
        }
      };
      this.onResize = () => this.updateStickyTop();
      this.onInput = () => {
        this.current = clamp(Number(this.range.value) || 0);
        this.paint();
      };
      this.pointerStart = event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointerId = event.pointerId;
        this.dragBounds = this.getBoundingClientRect();
        this.classList.add('is-dragging');
        this.range.setPointerCapture?.(event.pointerId);
        this.range.focus({preventScroll:true});
        this.pointerMove(event);
        event.preventDefault();
      };
      this.pointerMove = event => {
        if (this.pointerId !== event.pointerId || !this.dragBounds?.width) return;
        this.current = clamp((event.clientX-this.dragBounds.left)/this.dragBounds.width*100);
        this.paint();
      };
      this.pointerEnd = event => {
        if (this.pointerId === null || (event?.pointerId!==undefined && event.pointerId!==this.pointerId)) return;
        this.pointerId = null;
        this.classList.remove('is-dragging');
        if (this.mode.matches) this.onScroll();
      };
      this.observer = new IntersectionObserver(entries => {
        if (!this.mode.matches) {this.detachScroll();return;}
        if (entries[0]?.isIntersecting) this.attachScroll();
        else this.detachScroll();
      },{rootMargin:'300px 0px 300px 0px',threshold:0});
      this.observer.observe(this.track);
      this.mode.addEventListener?.('change',this.onMode);
      window.addEventListener('resize',this.onResize,{passive:true});
      if ('ResizeObserver' in window) {
        this.copyStageObserver = new ResizeObserver(() => this.updateStickyTop());
        this.copyStageObserver.observe(this.stage);
      }
      this.range.addEventListener('input',this.onInput);
      this.range.addEventListener('pointerdown',this.pointerStart);
      this.range.addEventListener('pointermove',this.pointerMove);
      this.range.addEventListener('pointerup',this.pointerEnd);
      this.range.addEventListener('pointercancel',this.pointerEnd);
      this.range.addEventListener('lostpointercapture',this.pointerEnd);
      this.paint();
      if (this.mode.matches) this.updateStickyTop();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.copyStageObserver?.disconnect();
      this.detachScroll?.();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.mode?.removeEventListener?.('change',this.onMode);
      window.removeEventListener('resize',this.onResize);
      this.range?.removeEventListener('input',this.onInput);
      this.range?.removeEventListener('pointerdown',this.pointerStart);
      this.range?.removeEventListener('pointermove',this.pointerMove);
      this.range?.removeEventListener('pointerup',this.pointerEnd);
      this.range?.removeEventListener('pointercancel',this.pointerEnd);
      this.range?.removeEventListener('lostpointercapture',this.pointerEnd);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npd-pdp-quality"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npd-quality-tabs')) {
  customElements.define('npd-quality-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.select = (tab, focus = false) => {
        this.tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
        this.panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      this.addEventListener('click', event => { const tab = event.target.closest('[role="tab"]'); if (tab && this.contains(tab)) this.select(tab); });
      this.addEventListener('keydown', event => {
        const i = this.tabs.indexOf(event.target);
        if (i < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next], true); }
      });
      this.editorSelect = event => { if (this.contains(event.target)) { const panel = event.target.closest('[role="tabpanel"]'); if (panel) this.select(this.tabs.find(t => t.getAttribute('aria-controls') === panel.id)); } };
      document.addEventListener('shopify:block:select', this.editorSelect);
    }
    disconnectedCallback() { document.removeEventListener('shopify:block:select', this.editorSelect); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npd-pdp-recording"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npd-recording-player')) {
  customElements.define('npd-recording-player', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.npd-recording__play');
      if (!this.video || !this.playButton) return;
      this.video.controls = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.inView = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onVisibility = () => this.syncPlayback();
      this.onMotion = () => this.syncPlayback();
      this.onManualPlay = () => {
        const attempt = this.video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(() => { this.playButton.hidden = true; })
            .catch(() => { this.playButton.hidden = false; });
        } else {
          this.playButton.hidden = true;
        }
      };
      this.playButton.addEventListener('click', this.onManualPlay);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener?.('change', this.onMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (!entry) return;
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          this.syncPlayback();
        }, { threshold: [0, 0.35, 0.65] });
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.syncPlayback();
      }
    }
    syncPlayback() {
      if (!this.video || !this.playButton) return;
      if (!this.inView || document.hidden) {
        this.video.pause();
        return;
      }
      if (this.motion.matches) {
        this.video.pause();
        this.playButton.hidden = false;
        return;
      }
      if (!this.video.paused) {
        this.playButton.hidden = true;
        return;
      }
      const attempt = this.video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(() => {
          if (!this.inView || document.hidden) this.video.pause();
          else this.playButton.hidden = true;
        }).catch(() => { if (this.inView && !document.hidden) this.playButton.hidden = false; });
      } else {
        this.playButton.hidden = true;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener?.('change', this.onMotion);
      this.playButton?.removeEventListener('click', this.onManualPlay);
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-ha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('driver-creator-reviews')) {
    customElements.define('driver-creator-reviews', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal:this.events.signal };
        const dialog = this.querySelector('dialog');
        const player = this.querySelector('[data-player]');
        if (!dialog || !player) return;
        this.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => {
          if (button.disabled) return;
          const template = document.getElementById(button.dataset.open);
          if (!template || !this.contains(template)) return;
          player.replaceChildren(template.content.cloneNode(true));
          this.querySelector('[data-dialog-title]').textContent = template.dataset.title;
          dialog.showModal();
        }, options));
        this.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', () => player.replaceChildren(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
      }
      disconnectedCallback() {
        this.querySelector('dialog')?.close();
        this.querySelector('[data-player]')?.replaceChildren();
        this.events?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starvis2-ha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('starvis-night-compare')) {
    customElements.define('starvis-night-compare', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal:this.events.signal };
        const board = this.querySelector('[data-board]');
        if (!board) return;
        board.querySelectorAll('img').forEach(image => { image.draggable = false; });
        board.addEventListener('dragstart', event => event.preventDefault(), options);
        if (board.getAttribute('aria-disabled') === 'true') return;
        let current = 50;
        const label = this.querySelector('.snv__label--after').textContent;
        const update = value => {
          const position = Math.round(Math.max(0,Math.min(100,Number(value))));
          current = position;
          board.setAttribute('aria-valuenow', String(position));
          board.setAttribute('aria-valuetext', `${position}% ${label}`);
          board.style.setProperty('--split', `${position}%`);
          this.querySelector('.snv__label--after').hidden = position < 8;
          this.querySelector('.snv__label--before').hidden = position > 92;
        };
        board.addEventListener('keydown', event => {
          const positions = { ArrowLeft:current - 2, ArrowDown:current - 2, ArrowRight:current + 2, ArrowUp:current + 2, Home:0, End:100 };
          if (!(event.key in positions)) return;
          event.preventDefault();
          update(positions[event.key]);
        }, options);
        const move = event => {
          const rect = board.getBoundingClientRect();
          if (rect.width) update((event.clientX - rect.left) / rect.width * 100);
        };
        let pointer = null;
        board.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          if (event.pointerType === 'mouse') event.preventDefault();
          pointer = event.pointerId;
          board.setPointerCapture(pointer);
          move(event);
        }, options);
        board.addEventListener('pointermove', event => { if (event.pointerId === pointer) move(event); }, options);
        board.addEventListener('pointerup', () => { pointer = null; }, options);
        board.addEventListener('pointercancel', () => { pointer = null; }, options);
        board.addEventListener('lostpointercapture', () => { pointer = null; }, options);
        update(current);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["std-pdp-installation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('std-pdp-install-video')) {
  customElements.define('std-pdp-install-video', class extends HTMLElement {
    embedUrl(rawUrl, autoplay) {
      let url;
      try { url = new URL(rawUrl.trim()); } catch { return null; }
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      const host = url.hostname.toLowerCase().replace(/^www\./, '');
      const parts = url.pathname.split('/').filter(Boolean);
      let id;
      let embed;
      if (host === 'youtu.be') {
        id = parts[0];
      } else if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
        id = url.searchParams.get('v');
        if (['embed', 'shorts', 'live'].includes(parts[0])) id = parts[1];
      } else if (['vimeo.com', 'player.vimeo.com'].includes(host)) {
        id = host === 'player.vimeo.com' ? parts[1] : parts[0];
        if (!/^\d+$/.test(id || '')) return null;
        embed = new URL('https://player.vimeo.com/video/' + id);
        const hash = url.searchParams.get('h') || (host === 'vimeo.com' ? parts[1] : null);
        if (hash && /^[a-zA-Z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
      }
      if (!embed) {
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return null;
        embed = new URL('https://www.youtube-nocookie.com/embed/' + id);
        embed.searchParams.set('playsinline', '1');
        embed.searchParams.set('rel', '0');
      }
      embed.searchParams.set('autoplay', autoplay ? '1' : '0');
      return embed.href;
    }
    connectedCallback() {
      this.button = this.querySelector('button');
      this.template = this.querySelector('template');
      if (!this.template || this.initialized) return;
      this.initialized = true;
      this.start = () => {
        if (!this.player) {
          const content = this.template.content.cloneNode(true);
          const iframe = content.querySelector('iframe');
          if (iframe) {
            const url = this.embedUrl(iframe.dataset.stdPdpUrl || '', !!this.button);
            if (!url) return;
            iframe.src = url;
          }
          this.player = document.createElement('div');
          this.player.className = 'std-pdp-video__player';
          this.player.append(content);
          this.append(this.player);
        }
        if (this.button) {
          document.querySelectorAll('std-pdp-install-video').forEach(player => {
            if (player !== this) player.stop?.();
          });
          this.button.hidden = true;
        }
        this.player.hidden = false;
        const media = this.player.querySelector('video,iframe');
        if (this.button) media?.focus();
        if (media?.tagName === 'VIDEO') media.play().catch(() => {});
      };
      this.button?.addEventListener('click', this.start);
      if (this.hasAttribute('data-std-pdp-direct')) this.start();
    }
    stop() {
      if (!this.player) return;
      if (!this.button) {
        const iframe = this.player.querySelector('iframe');
        if (iframe) {
          const url = this.embedUrl(iframe.dataset.stdPdpUrl || '', false);
          if (url) iframe.src = url;
        }
        return;
      }
      const video = this.player.querySelector('video');
      if (video) video.pause();
      else { this.player.remove(); this.player = null; }
      if (this.player) this.player.hidden = true;
      this.button.hidden = false;
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.start);
      this.player?.querySelector('video')?.pause();
      this.player?.remove();
      this.player = null;
      if (this.button) this.button.hidden = false;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["std-pdp-night"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('std-pdp-night-compare')) {
  customElements.define('std-pdp-night-compare', class extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type="range"]');
      this.track = this.closest('.std-pdp-night__scroll-track');
      this.stage = this.closest('.std-pdp-night__sticky');
      if (!this.range || !this.track || !this.stage) return;

      const clamp = x => Math.min(100,Math.max(0,x));
      this.current = clamp(Number(this.range.value) || 0);
      this.pointerId = null;
      this.frame = 0;
      this.listenScroll = false;
      this.mode = matchMedia('(min-width:990px) and (pointer:fine) and (prefers-reduced-motion:no-preference)');

      this.paint = () => {
        const p = clamp(this.current);
        this.style.setProperty('--std-pdp-position',p+'%');
        this.style.setProperty('--std-pdp-left-opacity',(p/100).toFixed(3));
        this.style.setProperty('--std-pdp-right-opacity',(1-p/100).toFixed(3));
        this.range.value = p.toFixed(1);
      };
      this.renderScroll = () => {
        this.frame = 0;
        if (!this.mode.matches || this.pointerId !== null) return;
        const rect = this.track.getBoundingClientRect();
        const stageHeight = this.stage.getBoundingClientRect().height;
        const stickyTop = parseFloat(getComputedStyle(this.stage).top) || 0;
        const travel = Math.max(1,rect.height-stageHeight);
        this.current = clamp((stickyTop-rect.top)/travel*100);
        this.paint();
      };
      this.onScroll = () => {
        if (!this.frame) this.frame=requestAnimationFrame(this.renderScroll);
      };
      this.attachScroll = () => {
        if (this.listenScroll) return;
        window.addEventListener('scroll',this.onScroll,{passive:true});
        this.listenScroll = true;
        this.onScroll();
      };
      this.detachScroll = () => {
        if (!this.listenScroll) return;
        window.removeEventListener('scroll',this.onScroll);
        this.listenScroll = false;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      };
      this.updateStickyTop = () => {
        if (!this.mode.matches) {
          this.track.style.removeProperty('--std-pdp-night-sticky-top');
          return;
        }
        const contentHeight = this.stage.getBoundingClientRect().height;
        this.track.style.setProperty('--std-pdp-night-sticky-top',
          Math.max(20, (window.innerHeight - contentHeight) / 2).toFixed(1) + 'px');
        this.onScroll();
      };
      this.onMode = () => {
        if (this.mode.matches) {
          this.updateStickyTop();
        } else {
          this.detachScroll();
          this.track.style.removeProperty('--std-pdp-night-sticky-top');
          this.paint();
        }
      };
      this.onResize = () => this.updateStickyTop();
      this.onInput = () => {
        this.current = clamp(Number(this.range.value) || 0);
        this.paint();
      };
      this.pointerStart = event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointerId = event.pointerId;
        this.dragBounds = this.getBoundingClientRect();
        this.classList.add('is-dragging');
        this.range.setPointerCapture?.(event.pointerId);
        this.range.focus({preventScroll:true});
        this.pointerMove(event);
        event.preventDefault();
      };
      this.pointerMove = event => {
        if (this.pointerId !== event.pointerId || !this.dragBounds?.width) return;
        this.current = clamp((event.clientX-this.dragBounds.left)/this.dragBounds.width*100);
        this.paint();
      };
      this.pointerEnd = event => {
        if (this.pointerId === null || (event?.pointerId!==undefined && event.pointerId!==this.pointerId)) return;
        this.pointerId = null;
        this.classList.remove('is-dragging');
        if (this.mode.matches) this.onScroll();
      };
      this.observer = new IntersectionObserver(entries => {
        if (!this.mode.matches) {this.detachScroll();return;}
        if (entries[0]?.isIntersecting) this.attachScroll();
        else this.detachScroll();
      },{rootMargin:'300px 0px 300px 0px',threshold:0});
      this.observer.observe(this.track);
      this.mode.addEventListener?.('change',this.onMode);
      window.addEventListener('resize',this.onResize,{passive:true});
      if ('ResizeObserver' in window) {
        this.copyStageObserver = new ResizeObserver(() => this.updateStickyTop());
        this.copyStageObserver.observe(this.stage);
      }
      this.range.addEventListener('input',this.onInput);
      this.range.addEventListener('pointerdown',this.pointerStart);
      this.range.addEventListener('pointermove',this.pointerMove);
      this.range.addEventListener('pointerup',this.pointerEnd);
      this.range.addEventListener('pointercancel',this.pointerEnd);
      this.range.addEventListener('lostpointercapture',this.pointerEnd);
      this.paint();
      if (this.mode.matches) this.updateStickyTop();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.copyStageObserver?.disconnect();
      this.detachScroll?.();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.mode?.removeEventListener?.('change',this.onMode);
      window.removeEventListener('resize',this.onResize);
      this.range?.removeEventListener('input',this.onInput);
      this.range?.removeEventListener('pointerdown',this.pointerStart);
      this.range?.removeEventListener('pointermove',this.pointerMove);
      this.range?.removeEventListener('pointerup',this.pointerEnd);
      this.range?.removeEventListener('pointercancel',this.pointerEnd);
      this.range?.removeEventListener('lostpointercapture',this.pointerEnd);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["std-pdp-quality"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('std-pdp-quality-tabs')) {
  customElements.define('std-pdp-quality-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.select = (tab, focus = false) => {
        this.tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
        this.panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      this.addEventListener('click', event => { const tab = event.target.closest('[role="tab"]'); if (tab && this.contains(tab)) this.select(tab); });
      this.addEventListener('keydown', event => {
        const i = this.tabs.indexOf(event.target);
        if (i < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next], true); }
      });
      this.editorSelect = event => { if (this.contains(event.target)) { const panel = event.target.closest('[role="tabpanel"]'); if (panel) this.select(this.tabs.find(t => t.getAttribute('aria-controls') === panel.id)); } };
      document.addEventListener('shopify:block:select', this.editorSelect);
    }
    disconnectedCallback() { document.removeEventListener('shopify:block:select', this.editorSelect); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["std-pdp-recording"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('std-pdp-recording-player')) {
  customElements.define('std-pdp-recording-player', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.std-pdp-recording__play');
      if (!this.video || !this.playButton) return;
      this.video.controls = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.inView = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onVisibility = () => this.syncPlayback();
      this.onMotion = () => this.syncPlayback();
      this.onManualPlay = () => {
        const attempt = this.video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(() => { this.playButton.hidden = true; })
            .catch(() => { this.playButton.hidden = false; });
        } else {
          this.playButton.hidden = true;
        }
      };
      this.playButton.addEventListener('click', this.onManualPlay);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener?.('change', this.onMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (!entry) return;
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          this.syncPlayback();
        }, { threshold: [0, 0.35, 0.65] });
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.syncPlayback();
      }
    }
    syncPlayback() {
      if (!this.video || !this.playButton) return;
      if (!this.inView || document.hidden) {
        this.video.pause();
        return;
      }
      if (this.motion.matches) {
        this.video.pause();
        this.playButton.hidden = false;
        return;
      }
      if (!this.video.paused) {
        this.playButton.hidden = true;
        return;
      }
      const attempt = this.video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(() => {
          if (!this.inView || document.hidden) this.video.pause();
          else this.playButton.hidden = true;
        }).catch(() => { if (this.inView && !document.hidden) this.playButton.hidden = false; });
      } else {
        this.playButton.hidden = true;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener?.('change', this.onMotion);
      this.playButton?.removeEventListener('click', this.onManualPlay);
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
